import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { SprachProvider } from './i18n'
import './styles.css'
// Nach styles.css: Die Merkmale des Schaufensters ersetzen die alten, und die
// neuen Bausteine (sf-…) haben ohnehin keine Gegner.
import './design.css'

const wurzel = document.getElementById('root')
if (!wurzel) throw new Error('Element #root fehlt in index.html')

createRoot(wurzel).render(
  <StrictMode>
    {/* Die Sprache steht über allem, auch über der App selbst: Schon deren
        erster Satz — „Laden wird geöffnet …" — gehört übersetzt, und der steht
        da, bevor die Grunddaten des Ladens eintreffen. */}
    <SprachProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </SprachProvider>
  </StrictMode>,
)
